import React, { useState, useEffect, useRef } from "react";

import Header from "../components/Header";
import { Box } from "@mui/material";
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import EmailIcon from '@mui/icons-material/Email';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import PersonIcon from '@mui/icons-material/Person';
import { MascaraTelefone } from "../../utils/MascaraTelefone";
import Footer from "../components/Footer";
import { Card, CardContent, Avatar, Typography, Rating } from "@mui/material";
import Modal from "../components/Modal";
import axios from "axios";
import AlertSuccess from "../components/AlertError";
import { motion } from "framer-motion";
import { ValidarEmail } from "../../utils/ValidarEmail";
import "./index.css";

const Home = () => {

    const [nome, setNome] = useState("");
    const [email, setEmail] = useState("");
    const [telefone, setTelefone] = useState("");
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [mensagem, setMensagem] = useState("");

    const inputStyles = {
        "& .MuiInputBase-input": { color: "white" },
        "& .MuiInputLabel-root": { color: "white", },
        "& .MuiOutlinedInput-notchedOutline": { borderColor: "white" },
        "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#1EFF86" },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#1EFF86" },
    };

    const avaliacoes = [
        {
            nome: <>Deny <b style={{color: "#1EFF86"}}>Barbie</b></>,
            ocupation: "Influencer/Produtora de Conteúdo",
            imagem: "assets/deny.png",
            rating: 5,
            comentario: "“Trabalho com eles a dois anos e são muito prestativos, sempre resolvem tudo bem rápido! Estou muito feliz e satisfeita com a equipe.”"
        },
        {
            nome: <>Carolina <b style={{color: "#1EFF86"}}>Dianas</b></>,
            ocupation: "Influencer/Produtora de Conteúdo",
            imagem: "assets/ismaila.png",
            rating: 5,
            comentario: <>
                <p>“Tinha muita dificuldade em encontrar uma contabilidade que atendesse exatamente ao que eu precisava, porque não entendo nada do assunto.</p>
                A Contblack superou minhas expectativas: o suporte é praticamente 24 horas, tudo é entregue nos prazos e eu não preciso me preocupar com nada. Hoje sei que minha empresa está totalmente segura com eles.”
            </>
        },
        {
            nome: <>Elis <b style={{color: "#1EFF86"}}>Nebsniak</b></>,
            ocupation: "Influencer/Produtora de Conteúdo",
            imagem: "assets/elis.png",
            rating: 5,
            comentario: "“Desde que contratamos a Contblack, estamos 100% satisfeitos. No início, surgiram várias dúvidas sobre a contabilidade digital, mas todas foram esclarecidas com rapidez e clareza. Os pagamentos são sempre gerados em dia e a equipe nos lembra constantemente de enviar as informações necessárias, o que traz muita tranquilidade ao nosso dia a dia. Nota 1000!”"
        },
        {
            nome: <>Marina <b style={{color: "#1EFF86"}}>Steele</b></>,
            ocupation: "Influencer/Produtora de Conteúdo",
            imagem: "assets/steele.png",
            rating: 5,
            comentario: "“Sempre tive uma ótima experiência com a empresa! Sempre que tenho dúvidas ou preciso de suporte, há alguém para me auxiliar e responder. Já estou há mais de um ano e pretendo permanecer por muito tempo.”"
        },
        {
            nome: <>Adry <b style={{color: "#1EFF86"}}>Rot</b></>,
            ocupation: "Influencer/Produtora de Conteúdo",
            imagem: "assets/hot.png",
            rating: 5,
            comentario: "“O trabalho da Contblack tem sido muito útil para mim. Ajuda muito, fico muito mais tranquila com o trabalho deles. Há muita transparência e competência; é muito bom para o meu dia a dia, para lidar com as contas.”"
        }
    ]



    const handleSubmit = async () => {
        setLoading(true);

        if (!nome || !telefone || !email) {
            setMensagem("Por favor, preencha todos os campos.");
            setOpenAlert(true);
            setLoading(false);
            return;
        }

        if (telefone.replace(/\D/g, '').length < 11) {
            setMensagem("Por favor, insira um número de telefone válido.");
            setOpenAlert(true);
            setLoading(false);
            return;
        }

        if (!ValidarEmail(email)) {
            setMensagem("Por favor, insira um e-mail válido.");
            setOpenAlert(true);
            setLoading(false);
            return;
        }
        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/api/salvarDadosLead`, {
                nome,
                telefone,
                email
            });
            setEmail("");
            setNome("");
            setTelefone("");
            setOpen(true);
        } catch (error) {
            console.error("Erro ao salvar os dados do lead:", error);
            setMensagem(error.response.data.mensagem || "Ocorreu um erro ao enviar o formulário. Tente novamente mais tarde.");
            setOpenAlert(true);
            setLoading(false);
        }
        setLoading(false);
    }

    const carouselRef = useRef(null);
    const [width, setWidth] = useState(0);

    useEffect(() => {
        if (!carouselRef.current) return;

        const observer = new ResizeObserver(() => {
            const scrollWidth = carouselRef.current.scrollWidth;
            const offsetWidth = carouselRef.current.offsetWidth;
            setWidth(scrollWidth - offsetWidth);
        });

        observer.observe(carouselRef.current);

        return () => observer.disconnect();
    }, []);

    return (
        <>
            <Header />

            <div style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#0A0A0A"
            }}>
                <motion.div
                    style={{
                        width: "80%",
                        margin: "0 auto",
                        padding: "50px 0",
                        color: "white",
                        textAlign: "center"
                    }}
                    initial={{ opacity: 0, y: 40 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7, ease: "easeOut" }}
                >
                    <h1 style={{ color: "#1EFF86" }}>
                        Contabilidade segura e discreta para quem vive de conteúdo
                    </h1>

                    <div style={{
                        marginTop: "20px",
                        fontSize: "1.2rem",
                        lineHeight: "1.6rem",
                        width: "80%",
                        margin: "20px auto 0 auto"
                    }}>
                        <p>
                            Conheça a Contblack, a solução que simplifica seus{" "}
                            <b style={{ color: "#1EFF86" }}>processos contábeis</b>, aumenta a produtividade e impulsiona o{" "}
                            <b style={{ color: "#1EFF86" }}>crescimento do seu negócio</b>.
                        </p>
                    </div>
                </motion.div>
            </div>
            <Box
                sx={{
                    width: "100%",
                    height: "fit-content",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 4
                }}
            >
                <Box sx={{ width: window.innerWidth <= 400 ? "60%" : "95%", maxWidth: 1000, textAlign: "center" }}>
                    {/* Container responsivo do vídeo */}
                    <Box
                        sx={{
                            position: "relative",
                            paddingBottom: "56.25%", // 16:9
                            height: 0,
                            overflow: "hidden",
                            borderRadius: 2,
                            mb: 4,
                            boxShadow: 3
                        }}
                    >
                        <iframe
                            src="/assets/Contblack.mp4"
                            title="Apresentação Contblack"
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%"
                            }}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    </Box>
                </Box>
            </Box>

            <Box
                sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                {/* CONTAINER PRINCIPAL */}
                <Box
                    sx={{
                        width: "80%",
                        maxWidth: 950,
                        textAlign: "center",
                        padding: "32px",
                        borderRadius: 12,
                        color: "white",
                    }}
                >
                    {/* TÍTULO */}
                    <Typography
                        variant="h4"
                        sx={{ mb: 1, color: "#1EFF86", fontWeight: 600 }}
                    >
                        Confiado por nossos clientes
                    </Typography>

                    {/* DESCRIÇÃO */}
                    <Typography sx={{ opacity: 0.8 }}>
                        Veja o que nossos clientes satisfeitos dizem sobre sua experiência com a
                        Contblack e como os ajudamos a alcançar seus objetivos.
                    </Typography>

                    {/* CARROSSEL COM DRAG */}
                    <motion.div
                        ref={carouselRef}
                        style={{
                            marginTop: "40px",
                            overflow: "hidden",
                            cursor: "grab",
                            width: "100%",
                        }}
                        whileTap={{ cursor: "grabbing" }}
                    >
                        <motion.div
                            drag="x"
                            dragConstraints={{ left: -width, right: 0 }}
                            style={{
                                display: "flex",
                                gap: "24px",
                                width: "100%",
                                marginRight: -10,

                            }}
                        >
                            {avaliacoes.map((avaliacao, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        flexShrink: 0,
                                    }}
                                >
                                    <Card
                                        sx={{
                                            width: 300,
                                            minHeight: 550,
                                            backgroundColor: "#111",
                                            color: "white",
                                            borderRadius: 3,
                                            marginRight: -1,
                                            p: 2,
                                            boxShadow: "0 0 20px rgba(0,0,0,0.4)",
                                            borderBottom: "2px solid #1EFF86",
                                            borderTop: "2px solid #1EFF86",
                                        }}
                                    >
                                        <CardContent sx={{ textAlign: "center" }}>
                                            <Avatar
                                                src={avaliacao.imagem}
                                                sx={{
                                                    width: 150,
                                                    height: 150,
                                                    margin: "0 auto",
                                                    border: "3px solid #1EFF86",
                                                }}
                                            />

                                            <Typography variant="h6" sx={{ mt: 2 }}>
                                                {avaliacao.nome}
                                            </Typography>

                                            <Typography variant="body2" sx={{ opacity: 0.8 }}>
                                                {avaliacao.ocupation}
                                            </Typography>

                                            <Rating
                                                readOnly
                                                value={avaliacao.rating}
                                                sx={{
                                                    mt: 1,
                                                    "& .MuiRating-iconFilled": { color: "#1EFF86" },
                                                    "& .MuiRating-iconEmpty": { color: "gray" },
                                                }}
                                            />

                                            <Typography
                                                variant="body2"
                                                sx={{ mt: 2, opacity: 0.9, fontStyle: "italic" }}
                                            >
                                                {avaliacao.comentario}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Box>
                            ))}
                        </motion.div>
                    </motion.div>
                </Box>
            </Box>


            <Box
                sx={{
                    width: "100%",
                    py: 4,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Box className="container">
                    <h1 style={{ marginBottom: 10, color: "#1EFF86" }}>Simplifique Já</h1>
                    <p style={{ opacity: 0.8 }}>Pronto para transformar seu negócio com a Contblack?</p>

                    <Box
                        sx={{
                            width: "100%",
                            mt: 5,
                            display: "flex",
                            flexDirection: "column",
                            gap: 3
                        }}
                    >
                        <TextField
                            label="Nome"
                            placeholder="Digite seu nome"
                            fullWidth
                            value={nome}
                            onChange={(e) => setNome(e.target.value)}
                            variant="outlined"
                            slotProps={{
                                input: {
                                    startAdornment: <InputAdornment position="start">
                                        <PersonIcon sx={{ color: "white" }} />
                                    </InputAdornment>
                                }
                            }}
                            sx={inputStyles}
                        />

                        <TextField
                            label="Número de Telefone"
                            fullWidth
                            placeholder="(99) 99999-9999"
                            value={telefone}
                            onChange={(e) => {
                                setTelefone(MascaraTelefone(e.target.value));
                            }}
                            variant="outlined"
                            slotProps={{
                                input: {
                                    startAdornment: <InputAdornment position="start">
                                        <PhoneAndroidIcon sx={{ color: "white" }} />
                                    </InputAdornment>
                                }
                            }}
                            sx={inputStyles}
                        />

                        <TextField
                            label="E-mail"
                            fullWidth
                            placeholder="Digite seu e-mail"
                            variant="outlined"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            slotProps={{
                                input: {
                                    startAdornment: <InputAdornment position="start">
                                        <EmailIcon sx={{ color: "white" }} />
                                    </InputAdornment>
                                }
                            }}
                            sx={inputStyles}
                        />

                        <Button
                            variant="contained"
                            disabled={loading}
                            sx={{
                                backgroundColor: "#1EFF86",
                                borderRadius: "17px 0 17px 0",
                                fontSize: "0.9rem",
                                fontWeight: 800,
                                py: 1.2,
                                color: "#000",
                                transition: "0.3s",
                                '&:hover': {
                                    backgroundColor: "#9C01B9",
                                    boxShadow: "0 4px 12px #9C01B9",
                                }
                            }}
                            onClick={handleSubmit}
                        >
                            Avançar
                        </Button>
                        <p style={{ fontSize: "12px" }}>Enviando esse formulário você concorda com nossa <a href="https://contblack.com.br/politica-de-privacidade" target="_blank" rel="noopener noreferrer" style={{ color: "#1EFF86" }}>política de privacidade</a>.</p>
                    </Box>
                </Box>
            </Box>


            <Footer />
            <Modal open={open} setOpen={setOpen} />
            <AlertSuccess open={openAlert} setOpen={setOpenAlert} mensagem={mensagem} />
        </>
    );
}

export default Home;